import { Component } from '@angular/core';
import { FooterService } from './footer.service';
import { NgIf } from '@angular/common';
import { Footer } from '../types/Footer';

@Component({
    selector: 'app-footer',
    imports: [NgIf],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent {

  footers: Footer[] = [];

  constructor(
    private footerService: FooterService
  ) {
  }

  ngOnInit() {
    this.getFooter();
  }

  getFooter() {
    
  }

  getValore(chiave: string) {
    return this.footers.find(footer => footer.chiave === chiave)?.valore;
  }

  getUfficio() {
    if (!this.getValore("comune") || !this.getValore("ufficio")) return null;
    return `${this.getValore("comune")} - ${this.getValore('ufficio')}`;
  }

  getTelefono() {
    if (!this.getValore('telefono')) return null;
    return `Telefono: ${this.getValore('telefono')}`;
  }

  getPostaElettronica() {
    if (!this.getValore('posta-elettronica')) return null;
    return `Posta Elettronica: ${this.getValore('posta-elettronica')}`;
  }

  anyContatto() {
    return this.getTelefono() || this.getPostaElettronica() || this.getUfficio() || this.getValore('posta-elettronica-certificata');
  }

}
